import React from 'react';
import { Table } from 'antd';
import { TableProps } from 'antd/lib/table';

export type { TableProps };

const ProTable: React.FC<TableProps<any>> = (props) => {
  const { children, ...resProps } = props;
  return <Table {...resProps}>{children}</Table>;
};

export default ProTable;
